import React from 'react';
import { ListItem, ListItemIcon, ListItemText, SxProps, Theme } from '@mui/material';
import { theme } from 'src/theme/mui-theme';
import { usePlannerDrag } from 'src/pages/PlannerPage/DeviceView/hooks/DragAndDrop/usePlannerDrag';
import { DraggableDevice } from 'src/pages/PlannerPage/DeviceView/hooks/DragAndDrop/draggableDevices';
import { alpha } from "@mui/material/styles";

const defaultSx: SxProps<Theme> = {
    cursor: 'grab',
    userSelect: 'none',
    ':hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.1)
    },
    ':active': {
        cursor: 'grabbing',
    },
};

const selectedSx: SxProps<Theme> = {
    ...defaultSx,
    backgroundColor: theme.palette.primary.light,
};

interface DraggableListItemProps {
    dragData: DraggableDevice;
    icon: React.ReactNode;
    label: string;
    children?: React.ReactNode;
    onClick?: () => void;
    sxOverride?: SxProps<Theme>;
    selected?: boolean;
    ref?: React.Ref<HTMLLIElement>;
}

export function DraggableListItem({ ref, dragData, icon, label, children, onClick, sxOverride, selected }: DraggableListItemProps) {
    const { onMouseDown, wasDraggedRef } = usePlannerDrag(dragData);

    const handleClick = onClick ? () => {
        if (wasDraggedRef.current) {
            wasDraggedRef.current = false;
            return;
        }
        onClick();
    } : undefined;

    return (
        <ListItem
            ref={ref}
            sx={sxOverride ?? (selected ? selectedSx : defaultSx)}
            onMouseDown={onMouseDown}
            onClick={handleClick}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={label} />
            {children}
        </ListItem>
    );
}